import { DotLottie, DotLottieWorker } from 'https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web@0.71.0/+esm';

class CoffeeBg extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const src = this.dataset.src;
    if (!src) return;
    this._init(src);
  }

  disconnectedCallback() {
    this._resizeObserver?.disconnect();
    this._dotLottie?.destroy();
  }

  _init(src) {
    src = new URL(src, window.location.href).href;

    const canvas = this.querySelector('.coffee-bg__player');
    if (!canvas) return;

    const dpr = window.devicePixelRatio || 1;

    const resizeCanvas = () => {
      const w = this.clientWidth * dpr;
      const h = this.clientHeight * dpr;
      if (canvas.width === w && canvas.height === h) return;
      canvas.width = w;
      canvas.height = h;
    };
    resizeCanvas();

    const LottiePlayer = typeof canvas.transferControlToOffscreen === 'function' ? DotLottieWorker : DotLottie;
    console.log('LottiePlayer', typeof canvas.transferControlToOffscreen === 'function');

    this._dotLottie = new LottiePlayer({
      canvas,
      src,
      autoplay: true,
      loop: false,
      layout: { fit: 'cover', align: [0.5, 0.5] },
      renderConfig: {
        devicePixelRatio: dpr,
        useFrameInterpolation: false,
        freezeOnOffscreen: true
      },
    });

    this._dotLottie.addEventListener('load', () => {
      const totalFrames = this._dotLottie.totalFrames;
      const markers = this._dotLottie.markers() || [];
      const loopMarker = markers.find(m => m.name === 'loop-start');
      const fps = totalFrames / this._dotLottie.duration;
      this._loopStart = loopMarker ? loopMarker.time : Math.floor(fps * 0.15);
      this._triggerFrame = Math.floor(totalFrames * 0.95);
    });

    this._dotLottie.addEventListener('frame', ({ currentFrame }) => {
      if (this._triggerFrame == null) return;
      if (currentFrame >= this._triggerFrame) {
        this._dotLottie.setFrame(this._loopStart);
        this._dotLottie.play();
      }
    });

    this._resizeObserver = new ResizeObserver(() => {
      resizeCanvas();
      this._dotLottie?.resize();
    });
    this._resizeObserver.observe(this);
  }
}

customElements.define('coffee-bg', CoffeeBg);
